import { EventBus } from 'quasar'
import { boot } from 'quasar/wrappers'

export default boot(async ({ app }) => {
  const bus = new EventBus()
  // for Options API
  app.config.globalProperties.$bus = bus
})
